import { VideoStreamingMode } from 'features/live/liveVideoStreaming';
import { breakpoint, isClientSide } from 'utility/constant';

/* eslint-disable no-unused-vars */
export enum enSizeAttributes {
  height = 'height',
  width = 'width',
  left = 'left',
  top = 'top',
}
/* eslint-enable no-unused-vars */

export type SizeAttributesType = `${enSizeAttributes}`;

export interface WindowResizePayloadType {
  height: number;
  width: number;
}

export interface WindowScrollPayloadType {
  left: number;
  top: number;
}

export type WindowSizeType = WindowResizePayloadType & WindowScrollPayloadType;

// Lighthouse uses
// - w 412 for mobile
// - w 1350 for desktop
const initialBoundingRect: WindowSizeType = {
  height: breakpoint.sm,
  width: breakpoint.lg,
  left: 0,
  top: 0,
};

if (isClientSide) {
  const { height, width, left, top } = document.documentElement.getBoundingClientRect() ?? {};
  if (initialBoundingRect.height !== height) {
    initialBoundingRect.height = height;
  }
  if (initialBoundingRect.width !== width) {
    initialBoundingRect.width = width;
  }
  if (initialBoundingRect.left !== left) {
    initialBoundingRect.left = left;
  }
  if (initialBoundingRect.top !== top) {
    initialBoundingRect.top = top;
  }
}

export { initialBoundingRect };

export type SettingsState = {
  boundingRect: WindowSizeType;
  streamingMode: VideoStreamingMode;
  isVisualizzazioneEstesa: boolean;
};

export const initialState: SettingsState = {
  boundingRect: initialBoundingRect,
  streamingMode: VideoStreamingMode.off,
  isVisualizzazioneEstesa: true,
};

export const HYDRATE = '__HYDRATE_ACTION__';
export interface hidrationActionType {
  type: typeof HYDRATE;
  payload: any;
}
export const hydrate = (payload: any): hidrationActionType => ({ type: HYDRATE, payload });

export const SET_PAYMENT_TYPE = '__SET_PAYMENT_TYPE_ACTION__';

export interface setPaymentTypeActionType {
  type: typeof SET_PAYMENT_TYPE;
  payload?: string;
}

export const setPaymentType = (payload?: string): setPaymentTypeActionType => ({ type: SET_PAYMENT_TYPE, payload });
